export default [
    {
      id: "q1",
      question: "What are the requirements for renting a car?",
      answer:
        "To rent a car, you must be at least 18 years old and possess a valid driver's license issued by your country of residence. International customers may need an International Driving Permit (IDP) alongside their domestic license. We also accept major credit cards for the security deposit.",
    },
    {
      id: "q2",
      question: "How can I make a reservation?",
      answer:
        "Reservations can be easily made online through our website. Simply select your desired pick-up and drop-off locations, dates, and times. You can also modify or cancel your reservation through the same platform.",
    },
    {
      id: "q3",
      question: "What types of cars do you offer?",
      answer:
        "Our extensive fleet includes a wide range of vehicles, from compact and economy cars for budget-conscious travelers to spacious SUVs and luxurious sedans for those seeking extra comfort and style.",
    },
    {
      id: "q4",
      question: "Is insurance included in the rental price?",
      answer:
        "Basic insurance coverage is included in the rental price, covering liability and collision damages. However, customers can choose to purchase additional coverage options for added peace of mind during their rental period.",
    },
    {
      id: "q5",
      question: "What is your fuel policy?",
      answer:
        "We operate on a 'full-to-full' fuel policy. We provide the car with a full tank of fuel, and we expect it to be returned with a full tank. This way, you only pay for the fuel you use.",
    },
    {
      id: "q6",
      question: "Are there any additional fees?",
      answer:
        "Our rental rates are comprehensive, but there might be additional charges for optional extras, such as GPS devices, child safety seats, and additional drivers. Additionally, airport and one-way rental fees may apply based on location and rental duration.",
    },
    {
      id: "q7",
      question: "What is your mileage policy?",
      answer:
        "Most of our rentals come with unlimited mileage. However, some specialty vehicles or promotional offers may have specific mileage restrictions. Please check the terms and conditions of your reservation for more details.",
    },
    {
      id: "q8",
      question: "Do you offer child safety seats or GPS devices?",
      answer:
        "Yes, we offer child safety seats suitable for various age groups and GPS navigation devices to ensure you have a stress-free journey. Simply add these options to your reservation during the booking process.",
    },
    {
      id: "q9",
      question: "What are your pick-up and drop-off procedures?",
      answer:
        "Our rental locations are conveniently situated for easy pick-up and drop-off. Our team will guide you through the process upon arrival and return. Please refer to your reservation confirmation for specific location details.",
    },
    {
      id: "q10",
      question: "Can I rent a car for someone else?",
      answer:
        "Yes, you can rent a car for someone else, but the person collecting the vehicle must present all necessary documentation and meet our rental requirements. This includes a valid driver's license, credit card, and other relevant identification.",
    },
    {
      id: "q11",
      question: "What should I do in case of an accident or breakdown?",
      answer:
        "In the event of an accident or breakdown, please contact our 24/7 emergency support hotline provided with your rental details. We will assist you promptly and provide necessary guidance or arrange for roadside assistance if needed.",
    },
    {
      id: "q12",
      question: "Can I cross borders with the rental car?",
      answer:
        "Cross-border travel may be allowed in some cases, but it's subject to approval and may involve additional fees or restrictions. Please inform our staff during the reservation process if you plan to travel across borders, so we can assist you accordingly.",
    },
    {
      id: "q13",
      question: "What is your policy on smoking or pets in the car?",
      answer:
        "For the comfort of all our customers, smoking is strictly prohibited in our rental cars. Additionally, we have pet-friendly options available. If you plan to travel with a pet, please inform us during the booking process, and we will ensure you get a suitable vehicle.",
    },
    {
      id: "q14",
      question: "Can I extend my rental period?",
      answer:
        "Extending your rental period may be possible based on vehicle availability. Please contact our customer support as soon as possible to inquire about an extension. Keep in mind that additional charges will apply for the extra rental duration.",
    },
    {
      id: "q15",
      question: "What payment methods do you accept?",
      answer:
        "We accept major credit cards, debit cards, and cash payments for the rental charges. However, a credit card is typically required for the security deposit. Please note that some locations may have specific payment policies, so check with us for more information.",
    },
    {
      id: "q16",
      question: "Do you offer discounts or loyalty programs?",
      answer:
        "Yes, we often run promotions and special offers, especially for loyal customers. Additionally, we have a loyalty program that rewards our frequent renters with exclusive benefits and discounts. Check our website or contact our customer support for more details.",
    },
    {
      id: "q17",
      question: "How far in advance should I book a rental car?",
      answer:
        "Booking in advance is highly recommended, especially during peak travel seasons or busy periods. By reserving your rental car early, you can secure your preferred vehicle and often enjoy better rates.",
    },
    {
      id: "q18",
      question: "What is your cancellation policy?",
      answer:
        "Our cancellation policy varies based on the rental duration and location. Generally, cancellations made within a specific window before the rental period will incur no or minimal charges. For detailed information, review our cancellation policy during the booking process.",
    },
    {
      id: "q19",
      question: "Can I rent a car if I am under 25 years old?",
      answer:
        "Yes, we offer rentals to customers between the ages of 21 and 24. However, young drivers may be subject to a 'Young Driver Fee.' This fee helps cover the higher insurance risk associated with younger drivers. Please check with us for specific details and requirements.",
    },
    {
      id: "q20",
      question: "Do you have any special services for disabled customers?",
      answer:
        "Yes, we strive to accommodate the needs of all our customers, including disabled travelers. We offer accessible vehicles and various accommodations to ensure a comfortable rental experience. Please contact us in advance to discuss your requirements and make the necessary arrangements.",
    },
  ];
  